const MONTH_NAMES = [
    'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня',
    'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'
];

export const getFormattedDate = (date, prefomattedDate = false, hideYear = false) => {
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();
  
    if (minutes < 10) {
        // Добавляем ведущий ноль к минутам
        minutes = `0${minutes}`;
    }
  
    if (prefomattedDate) {
        // Сегодня в 10:20
        // Вчера в 10:20
        return `${prefomattedDate}`; // в ${hours}:${minutes}`;
    }
  
    if (hideYear) {
        // 10 Января в 10:20
        return `${day} ${month}`; // в ${hours}:${minutes}`;
    }
  
    // 10 Января 2017. в 10:20
    return `${day} ${month} ${year}`; // в ${hours}:${minutes}`;
}

export const timeAgo = (dateParam) => {
    if (!dateParam) {
        return null;
    }
  
    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();
  
    if (seconds < 5) {
        return 'только что';
    } else if (seconds < 60) {
        return `${seconds} секунд назад`;
    } else if (seconds < 90) {
        return 'около минуты назад';
    } else if (minutes < 60) {
        return `${minutes} минут назад`;
    } else if (isToday) {
        return getFormattedDate(date, 'Сегодня'); // Сегодня в 10:20
    } else if (isYesterday) {
        return getFormattedDate(date, 'Вчера'); // Вчера в 10:20
    } else if (isThisYear) {
        return getFormattedDate(date, false, true); // 10 Января в 10:20
    }
  
    return getFormattedDate(date); // 10 Января 2017. в 10:20
}
